import consumerApi from "api/services/consumer-api";
import { Article } from "custom-types/Article";
import logError from "utils/logError";

const getArticles = async (
  take: number,
  tags?: string[]
): Promise<Article[]> => {
  let params = {
    "sort[0][date]": "desc",
    take: take || 5,
  };

  if (tags) {
    const tagsObj: { tags: string[] } = { tags: tags };
    params = { ...params, ...tagsObj };
  }

  try {
    const {
      data: { data },
    } = await consumerApi.get(`/api/articles/v1`, {
      params,
    });

    return data || [];
  } catch (e) {
    logError(e.message, {
      functionName: "getArticles",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return [];
  }
};

export default getArticles;
